import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-900 bg-opacity-75" }, null, -1)
const _hoisted_3 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end justify-center min-h-full p-4 text-center sm:items-center sm:p-0" }
const _hoisted_5 = { class: "relative w-full text-left transition-all transform bg-white rounded shadow sm:my-8 sm:w-full sm:max-w-lg" }
const _hoisted_6 = { class: "bg-white" }
const _hoisted_7 = { class: "flex items-center justify-between border-b border-gray-400" }
const _hoisted_8 = { class: "w-full px-2 py-4 text-left" }
const _hoisted_9 = {
  class: "text-lg font-medium leading-6 text-gray-900",
  id: "modal-title"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-x-lg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "p-4 space-y-2" }
const _hoisted_13 = ["onSubmit"]
const _hoisted_14 = { class: "mt-4 text-sm font-medium capitalize" }
const _hoisted_15 = { class: "mt-4 text-sm font-medium capitalize" }
const _hoisted_16 = { class: "mt-4 text-sm font-medium capitalize" }
const _hoisted_17 = { class: "mt-4 text-sm font-medium capitalize" }
const _hoisted_18 = { class: "flex justify-center px-4 py-3 bg-gray-50" }

import { PropType, ref } from "vue";

import { useI18n } from "vue-i18n";

import DefaultButton from "../DefaultButton.vue";

import { useGlobalStore } from "@/store";
import { Event } from "@/types";
import api from "@/api/api";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrainerManualAdd',
  props: {
  isOpen: {
    type: Boolean,
    required: true,
  },
  event: {
    type: Object as PropType<Event>,
    required: true,
  },
},
  emits: ["close", "create"],
  setup(__props, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();
const globalStore = useGlobalStore();



const selectedUser = ref({
  first_name: "",
  last_name: "",
  email: "",
  sub_organisation: "",
});

const isAddingToCourse = ref(false);

async function createManualBooking() {
  try {
    if (!selectedUser.value?.first_name || !selectedUser.value?.last_name || !selectedUser.value?.email) {
      globalStore.toast("ERROR", "Please ensure the user exists and try again.");
      return;
    }

    const validCheckRequest = (await api.users.checkValidDelegate(props.event.id, selectedUser.value)).data;

    if (!validCheckRequest) {
      return;
    }

    if (validCheckRequest.valid && validCheckRequest.user) {
      console.log("[ Booking ] Creating Manual Booking for User", selectedUser.value);
      const response = await api.bookings.createManualBooking({ user_id: validCheckRequest.user.id, event_id: props.event.id, sub_organisation: selectedUser.value.sub_organisation });
      globalStore.toast("SUCCESS", `Added user to Event - Booking ID #${response.data.booking.id}`);
      emits("create");
      resetForm();
      emits("close");
    } else {
      globalStore.toast("ERROR", validCheckRequest.error!);
      return;
    }
    
  } catch (error) {
    console.log(error);
  }
}

function resetForm() {
  selectedUser.value = {
    first_name: "",
    last_name: "",
    email: "",
    sub_organisation: "",
  };
} 

function close() {
  resetForm();
  emits("close");
}

return (_ctx: any,_cache: any) => {
  return (props.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref($t)("add-user-to-course")), 1)
                  ]),
                  _createElementVNode("div", { class: "py-4 pl-2 pr-4" }, [
                    _createElementVNode("button", { onClick: close }, _hoisted_11)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", null, _toDisplayString(_unref($t)('trainer-manual-add-helptext')), 1)
                ]),
                _createElementVNode("form", {
                  class: "px-4 pb-8 space-y-2.5 border-b border-gray-400",
                  onSubmit: _withModifiers(createManualBooking, ["prevent"])
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_unref($t)("first-name")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "name",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedUser.value.first_name) = $event)),
                      placeholder: "First Name",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, selectedUser.value.first_name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_unref($t)("last-name")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "name",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedUser.value.last_name) = $event)),
                      placeholder: "Last Name",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, selectedUser.value.last_name]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, _toDisplayString(_unref($t)('redeem-license-email-helptext')), 1),
                    _createElementVNode("label", _hoisted_16, _toDisplayString(_unref($t)("email-address")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedUser.value.email) = $event)),
                      placeholder: "Email Address",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, selectedUser.value.email]
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_unref($t)("organisation")), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      id: "name",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedUser.value.sub_organisation) = $event)),
                      placeholder: "Organisation",
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                      required: ""
                    }, null, 512), [
                      [_vModelText, selectedUser.value.sub_organisation]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(DefaultButton, {
                      type: "primary",
                      "is-form-submit": true,
                      disabled: isAddingToCourse.value,
                      loading: isAddingToCourse.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("add-user-to-course")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "loading"])
                  ])
                ], 40, _hoisted_13)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})